module.exports = __webpack_public_path__ + "img/cover-subscription.c826f2e3.png";